import React, { useCallback, useEffect, useMemo, useState, } from 'react';
import { Form, Card, OverlayTrigger, Tooltip, CardGroup, Container } from "react-bootstrap";
import { trackPromise } from "react-promise-tracker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle, faEdit, faTrash, faMagnifyingGlass, faCheckCircle, faTimesCircle, faSpinner, faWindowMinimize } from "@fortawesome/free-solid-svg-icons";
import Swal from 'sweetalert2';
import './style.scss';
import ModalNovoTemplate from "./ModalNovoTamplate";
import MidiaSocialIcone from "../../../components/MidiaSocialIcone";
import caAPI from "../../../services/caAPI";
import DommusBarraTitulo from "../../../components/DommusBarraTitulo";
import ItemBarraTitulo from "../../../components/DommusBarraTitulo/ItemBarraTitulo";
import DommusTabelaPaginada from "../../../components/DommusTabelaPaginada";
import { Interweave } from 'interweave';
import FormDisparoEmMassa from './FormDisparoEmMassa';
import { DommusModalFullScreen } from '../../../components/DommusModalFullScreen';
import { FiltroTemplate } from './FiltroTemplate';
import ModalDommus from '../../../components/Modal';
import DommusTabelaPaginadaControlada from '../../../components/DommusTabelaPaginadaControlada';
import ReactTooltip from 'react-tooltip';

export default function Template() {
  const [listaTemplates, setListaTemplates] = useState([]);
  const [openModalNovoTemplate, setOpenModalNovoTemplate] = useState(false);
  const [openModalEditarTemplate, setOpenModalEditarTemplate] = useState(false);
  const [openModalFiltroTemplate, setOpenModalFiltroTemplate] = useState(false);
  const [filtro, setFiltro] = useState({});
  const [idTemplate, setIdTemplate] = useState();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(null);

  useEffect(() => {
    if(page === 1){
      handleAtualizaListaTemplates(filtro, true);
    }
    handleAtualizaListaTemplates();
  }, [page, limit]);

  function handleAtualizaListaTemplates (filtroLocal={}, somente_total=false) {
    let filtroTemp = filtro;
    if(Object.keys(filtroLocal).length){
      filtroTemp = filtroLocal;
    }
    const payload = {
      page,
      limit,
      somente_total,
      ...filtroTemp
    }

    trackPromise(
      caAPI.template.list(payload).then(res => {
        if(somente_total){
          setTotal(res?.data?.total);
        }else{
          setListaTemplates(res.data);
        }
      }).catch(err => {
        Swal.fire({
          titleText: "Erro",
          text: "Houve um problema ao buscar os template  " + err,
          icon: 'error'
        });
      }))
  }

  const handleAplicarFiltro = useCallback((filtros) => {
    setOpenModalFiltroTemplate(false);
    setFiltro(filtros);
    if(page === 1){
      handleAtualizaListaTemplates(filtros, true);
      handleAtualizaListaTemplates(filtros, false);
    }else{
      setTimeout(() => {setPage(1)}, 200);
    }
  },[])

  const thead = (
    <tr >
      <th style={{ width: '1%' }} className='text-center' data-tip="Aprovação Template Whatsapp">
        <FontAwesomeIcon icon={faCheckCircle} color='green'/>
      </th>
      <th style={{ width: '1%' }}>
        ID:
      </th>
      <th style={{ width: '3%' }} className='text-center'>
        Meio:
      </th>
      <th>
        Nome:
      </th>
      <th>
        Atendimento:
      </th>
      <th>
        Mensagem:
      </th>
      <th style={{ width: '5%' }}>
        Opções:
      </th>
    </tr>
  );

  const handleResolveStatusAprovacaoTemplate = (status) =>{
    let icon = <></>;
    let tooltip = "";
    switch(status){
      case "approved":
        tooltip = "Template Aprovado";
        icon = <FontAwesomeIcon icon={faCheckCircle} color='green'/>
        break;
      case "rejected":
        tooltip = "Template Rejeitado";
        icon = <FontAwesomeIcon icon={faTimesCircle} color='red'/>
        break;
      case "received":
      case "pending":
        tooltip = "Template em Análise";
        icon = <FontAwesomeIcon icon={faSpinner} color='grey'/>
        break;
      case "unsubmitted":
        tooltip = "Template Não Enviado para Análise";
        icon = <FontAwesomeIcon icon={faWindowMinimize} color='grey'/>
        break;
      default:
        icon = <></>
    }

    return (
      <OverlayTrigger 
        key={`tooltip-${status}`}
        placement="top"
        overlay={
          <Tooltip id={`tooltip-${status}`}>
            {tooltip}
          </Tooltip>
        }
      >
        {icon}
      </OverlayTrigger>
    )
  }

  const linhas = useMemo(() => {
    return (
    listaTemplates.map((template, index) => (
      <tr key={index}>
        <th>
            {handleResolveStatusAprovacaoTemplate(template?.status_aprovacao_whatsapp?.status)}
        </th>
        <th >
          {template.id}
        </th>
        <th>
          <CardGroup>
            {template.meios && template.meios.map((meio) =>
              <div className="tabelaMidias" key={meio.id}>
                <Card className="midiaCard">
                  <Card.Body className="midiaCorpo">
                    <Form.Check
                      className="midiaListaTemplate"
                      value={meio.slug}
                    >
                      <Form.Check.Input />
                      <Form.Check.Label>
                        <MidiaSocialIcone midia={meio.slug} />
                      </Form.Check.Label>
                    </Form.Check>
                  </Card.Body>
                </Card>
              </div>
            )}
          </CardGroup>
        </th>
        <th>
          {template.nome}
        </th>
        <th>
          {template.tipos && template.tipos.map((tipo) => <p key={tipo.id}>{tipo.descricao}</p>)}
        </th>
        <th>
          <div className='dados-do-template' dangerouslySetInnerHTML={{ __html: template?.mensagem ?? "" }} />
        </th>
        <th>
          <div className="opcoesTemplate">
          {
            template.meios && template.meios.some(meio => meio.slug == 'sms') && <OverlayTrigger
              key="buttonDispararEmMassa"
              placement="top"
              overlay={
                <Tooltip id={`tooltip-disparo`}>
                  Disparar envio em massa.
                </Tooltip>
              }
            >
              <div className="buttonDispararEmMassa"
                   ata-tip="Enviar em Massa">
                   <FormDisparoEmMassa idTemplate={template.id}/>
              </div>
            </OverlayTrigger>
          }
            <OverlayTrigger
              key="buttonEditarAnotacao"
              placement="top"
              overlay={
                <Tooltip id={`tooltip-editar`}>
                  Editar
                </Tooltip>
              }
            >
              <div className="buttonEditarAnotacao"
                   onClick={()=>
                     {
                       setIdTemplate(template.id);
                       setOpenModalEditarTemplate(true);
                     }
                   }
                   ata-tip="Editar Introdução">
                <FontAwesomeIcon icon={faEdit} />
              </div>
            </OverlayTrigger>
            <OverlayTrigger
              key="buttonExcluirAnotacao"
              placement="top"
              overlay={
                <Tooltip id={`tooltip-excluir`}>
                  Excluir
                </Tooltip>
              }
            >
              <>
                {template.padrao === 'N' &&
                <div className="buttonExcluirAnotacao"
                     onClick={() => removeTemplate(template.id)}
                     ata-tip="Editar Introdução">
                  <FontAwesomeIcon icon={faTrash} />
                </div>
                }
              </>
            </OverlayTrigger>
          </div>
        </th>
      </tr>
    ))
    );
  }, [listaTemplates]);

  const updateListaTemplates = useCallback(novoTemplate => {
    atualizarListaTemplatesOrdemDecrescente(lista => [...lista, novoTemplate]);
  }, [])


  const removeTemplate = (id_template) => {
    Swal.fire({
      titleText: "Apagar o template?",
      text: "Tem certeza que deseja apagar o Template?",
      icon: 'question',
      showCloseButton: false,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: 'Sim, Apagar!',
      cancelButtonText: 'Não!',
      customClass: {
        confirmButton: 'btn btn-primary mr-3',
        cancelButton: 'btn btn-danger'
      },
      buttonsStyling: false
    }).then(
      (result) => {
        if (result.value) {
          trackPromise(
            caAPI.template.deletar(id_template).then(res => {
              const templateIndex = listaTemplates.findIndex(template => template.id === id_template);
              let novaLista = [...listaTemplates];
              novaLista.splice(templateIndex, 1)
              setListaTemplates(novaLista);
            }).catch(e => {
              Swal.fire({
                titleText: "Erro",
                text: "Houve um problema ao excluir o Template " + e,
                icon: 'error'
              });
            })
          )
        }
      }
    )
  };

  function atualizarListaTemplatesOrdemDecrescente(novaLista) {
    setListaTemplates(novaLista.reverse())
  }

  return (
    <Container fluid>
      <ReactTooltip/>
      <DommusBarraTitulo>
        <ItemBarraTitulo>
          Templates
        </ItemBarraTitulo>
        <ItemBarraTitulo classe="btn" onClick={() => setOpenModalFiltroTemplate(true)}>
          <FontAwesomeIcon icon={faMagnifyingGlass} color="#265d9c" size="lg" />
        </ItemBarraTitulo>
        <ItemBarraTitulo classe="btn" onClick={() => setOpenModalNovoTemplate(true)}>
          <FontAwesomeIcon icon={faPlusCircle} color="#4caf50" size="lg" />
        </ItemBarraTitulo>
      </DommusBarraTitulo>
      
      <div className='tela-templates'>
        <DommusTabelaPaginadaControlada
          linhasCabecalho={thead}
          optionsTabela={{ bordered: true }}
          linhasCorpo={linhas}
          pagina={page}
          setPagina={setPage}
          setTamanhoPagina={setLimit}
          tamanhoPagina={limit}
          tamanhoTotal={total}
        />
      </div>

      <ModalDommus 
        titulo="Filtro" 
        open={openModalFiltroTemplate} 
        close={() => setOpenModalFiltroTemplate(false)}
      >
        <FiltroTemplate handleAplicarFiltro={handleAplicarFiltro} filtro={filtro} closeModal={() => setOpenModalFiltroTemplate(false)}/>
      </ModalDommus>

      <DommusModalFullScreen titulo="Novo Template" open={openModalNovoTemplate} close={() => setOpenModalNovoTemplate(false)}>
        <ModalNovoTemplate handleAtualizaListaTemplates={handleAtualizaListaTemplates}
                           updateListaTemplates={()=>updateListaTemplates}
                           setOpenModalNovoTemplate={setOpenModalNovoTemplate} />
      </DommusModalFullScreen>

      <DommusModalFullScreen titulo="Editar Template"
                   open={openModalEditarTemplate}
                   close={() => setOpenModalEditarTemplate(false)}>
        <ModalNovoTemplate handleAtualizaListaTemplates={handleAtualizaListaTemplates}
                           updateListaTemplates={()=>updateListaTemplates}
                           setOpenModalNovoTemplate={setOpenModalEditarTemplate}
                           idTemplate={idTemplate}/>
      </DommusModalFullScreen>
    </Container>
  );
}
